export default __webpack_public_path__ + "static/media/TheNewYear_02.777b52ad.png";